<script setup lang="ts">
defineProps<{
  fill?: string;
}>();
</script>

<template>
  <svg
    width="40"
    height="34"
    viewBox="0 0 40 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1124 2.9233C26.0101 -0.974432 32.3291 -0.974432 36.2268 2.9233C40.1245 6.82103 40.1245 13.14 36.2268 17.0377L34.1256 19.139L34.1544 19.1678L20.0179 33.3043L5.88142 19.1678L5.88589 19.1634L3.77612 17.0536C-0.125242 13.1529 -0.125242 6.82738 3.77612 2.92602C7.67747 -0.97534 14.0023 -0.97534 17.9037 2.92602L20.0067 5.029L22.1124 2.9233Z"
      fill="#FC6371"
    />
  </svg>
</template>
